<script>

    import layer3d from "@/mixins/threeBoxLayer"

    export default{

        mixins:[layer3d],
        
        name:"catedral",

        data(){
            return {
                loadDelay:0,
                context:'mapbox',
                modelName:"catedral",
                modelDir:"/models3d/",
                rotation:[90,0,0,'ZXY'],
                scale:[7,7,7],
                zoomScaleFactor:[[11,13],[15,3],[16,1]],
                coordinates: [-47.87550800253288,-15.798343786590522]
            }
        },

        computed:{

            geoJSON:function(){
                return {
                    "type": "FeatureCollection",
                    "features": [{
                        "type": "Feature",
                        "geometry": {
                            "type": "Point",
                            "coordinates":this.coordinates
                        },
                        "properties":{
                            key:"catedral",
                            scale:this.scale,//[5,5,5],
                            rotation:this.rotation,//[0,0,7,'XYZ'],
                            zoomScaleFactor:this.zoomScaleFactor,//[0,0,7,'XYZ'],
                        }
                    } ]
                }
            },
        },


        watch:{
            geoJSON:function(){

                // this.animatePoints(4, false)
            }
        },

        methods:{

        },

     
    }


</script>